import messages from "@smartmixin/i18n/dist/translations/nl.json";

export default messages;
